import { ChangeEvent } from 'react';
import { TextInput } from '../../Calculators/calculator-revamp/components/form-components/InputBox';
import { AtcTaxesPaidData } from '../Atc-calculator-constants';
import { CALCULATOR_TAB_PROPS } from '../types';
import AtcAdvanceTax from './atc-advance-tax';
import { handleTrack } from '../../../utils/tracker';
import { removeCommas } from '../../Utils/CommonUtils';

const AtcTaxPaid = ({
  hasError,
  setGlobalError,
  setInputData,
  inputTabData,
}: CALCULATOR_TAB_PROPS) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const key = e.target.id;
    const value = removeCommas(e.target.value);
    handleTrack({ label: `ATC_Tax_paid_${key}` });
    setInputData?.((prev) => ({ ...prev, [key]: value }));
  };
  return (
    <>
      <div className="w-2/4 sm:w-full font-medium">
        {AtcTaxesPaidData.map((props, index) => (
          <TextInput
            key={index}
            {...props}
            value={`${inputTabData?.[props.id]}` || ''}
            hasError={hasError}
            setGlobalError={setGlobalError}
            onTextChangeFn={handleChange}
          />
        ))}
      </div>
      <AtcAdvanceTax
        hasError={hasError}
        setGlobalError={setGlobalError}
        setInputData={setInputData}
        inputTabData={inputTabData}
      />
    </>
  );
};
export default AtcTaxPaid;
